/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgKeyMetrics = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h8.618l2 4H22v16H2zm2 2v16h16V8h-8.618l-2-4z" />
        <path d="M9.623 11.333 9.895 9h1.988l-.247 2.333h1.32L13.229 9h1.988l-.247 2.333H17l-.22 2h-2.033l-.148 1.334H17l-.22 2h-2.404L14.105 19h-1.988l.247-2.333h-1.32L10.771 19H8.784l.247-2.333H7l.22-2h2.033l.148-1.334H7l.22-2zm1.79 2-.148 1.334h1.321l.149-1.334z" />
      </g>
    </g>
  </Icon>
);
export { SvgKeyMetrics as KeyMetrics };
